import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
import _ from 'lodash';
let SpaceCapacityModelImpl = class SpaceCapacityModelImpl {
    constructor() {
        this._spaceCapacity = proxy(null);
    }
    get spaceCapacity() {
        return this._spaceCapacity.value;
    }
    updateSpaceCapacity(spaceCapacity) {
        this._spaceCapacity.value = {
            ...spaceCapacity,
        };
    }
    getSpaceCapacityByKey(key) {
        return _.get(this.spaceCapacity, key, 0);
    }
    subscribeSpaceCapacity(callback) {
        const dispose = subscribe(() => this._spaceCapacity.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
SpaceCapacityModelImpl = __decorate([
    injectable()
], SpaceCapacityModelImpl);
export { SpaceCapacityModelImpl };
